import React, { useMemo } from 'react';

import { graphql } from 'gatsby';
import { getImage } from '../../utils/media';
import GridSectionDS from 'design-system/src/components/organisms/GridSection';
import { CardValueProps } from 'design-system/src/components/molecules/CardValue';

function createAlternatingPattern(
    images: CardValueProps[],
    values: CardValueProps[],
) {
    if (!images.length || !values.length) {
        return values.map((value) => ({
            ...value,
            variant: 'content',
        }));
    }

    const result: CardValueProps[] = [];

    let imagesToDistribute = [...images];
    if (images.length > 0 && values.length > 0) {
        while (imagesToDistribute.length < values.length) {
            imagesToDistribute = [...imagesToDistribute, ...images];
        }
    }

    values.forEach((value, index) => {
        const imageIsFirst = Math.floor(index / 2) % 2 === 0;
        const image = imagesToDistribute.shift();

        if (imageIsFirst) {
            result.push({
                variant: 'image',
                showOnLg: true,
                image: image,
            } as any);
            result.push({
                ...value,
                variant: 'content',
            });
        } else {
            result.push({
                ...value,
                variant: 'content',
            });
            result.push({
                variant: 'image',
                showOnLg: true,
                image: image,
            } as any);
        }
    });

    if (images.length) {
        const mobileImagePostion = Math.floor(result.length / 2);
        result.splice(mobileImagePostion, 0, {
            variant: 'image',
            image: images[0],
            showOnlyXs: true,
        } as any);
    }

    return result;
}

export default function GridInfo1Section({ images, values, ...props }: any) {
    const formattedItems = useMemo(
        () =>
            createAlternatingPattern(
                images?.length ? images.map(getImage).filter(Boolean) : [],
                values,
            ),
        [images, values],
    );

    return (
        <GridSectionDS
            {...props}
            items={formattedItems}
            variant="grid-info-1"
        />
    );
}

export const query = graphql`
    fragment DatoCmsGridInfo1Section on DatoCmsGridInfo1Section {
        title
        cta {
            ...Button
        }
        values {
            value
            description: title
        }
        images {
            ...SourceMedia
            gatsbyImageData(width: 720, placeholder: BLURRED)
        }
    }
`;
